import {useEffect, useState} from "react";
import {useTheme} from "styled-components";
import {toast} from "react-toastify";
import {OverlayContainer} from "./overlays";
import {DialogContainer, DialogFooter} from "./dialogs";
import {CvvButton} from "./buttons";
import {Theme} from "../theme";
import {appStore} from "../index";

const WARNING_TOAST_ID = 'reservation-warning';

interface ExtendProps {
    canExtend: boolean;
    onExtend: () => any;
}

interface WarningToastProps extends ExtendProps {
    /** prag opozorila pride s strežnika, zato ga ne zapisujemo v besedilo na pamet */
    minutes: number;
}

interface ReservationDialogProps {
    title: string;
    body: string;
    action: string;
    secondary?: string;
    onAction: () => any;
    onSecondary?: () => any;
}

const ReservationDialog = (props: ReservationDialogProps) => {
    const [first, setFirst] = useState(true);
    useEffect(() => setFirst(false), []);
    const theme = useTheme() as Theme;

    const button = (label: string, onClick: () => any, primary: boolean) =>
        <CvvButton
            onClick={() => {
                setFirst(true);
                setTimeout(() => {
                    appStore.hideDialog();
                    onClick();
                }, 100);
            }}
            height={'42px'}
            width={'190px'}
            style={{
                padding: 0,
                borderRadius: '5px',
                justifyContent: 'center',
                // na ozkih zaslonih se gumba skrčita, da ostaneta v oknu
                flex: '1 1 0',
                minWidth: 0,
                maxWidth: '190px',
                backgroundColor: primary ? undefined : theme.shade,
            }}>{label}</CvvButton>;

    return <OverlayContainer hidden={first}>
        {/* DialogContainer svojo širino računa iz propa `width`; ker jo tu podamo prek
            style, mora rob do roba zaslona poskrbeti calc - sicer okno na ozkih
            zaslonih sega čez rob */}
        <DialogContainer style={{
            padding: 0,
            width: 'calc(100% - 48px)',
            maxWidth: '460px',
            height: 'auto',
        }}>
            <div style={{
                padding: '28px 32px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                gap: '10px',
            }}>
                <theme.textTheme.headline4.span>{props.title}</theme.textTheme.headline4.span>
                <theme.textTheme.body.span>{props.body}</theme.textTheme.body.span>
            </div>
            <DialogFooter style={{height: '56px', padding: '0 16px', gap: '16px', boxSizing: 'border-box'}}>
                {props.secondary && props.onSecondary &&
                    button(props.secondary, props.onSecondary, false)}
                {button(props.action, props.onAction, true)}
            </DialogFooter>
        </DialogContainer>
    </OverlayContainer>;
};

/** Zadnja minuta - opozorilo, ki ga uporabnik ne more spregledati. */
export const ShowReservationExpiringDialog = (props: ExtendProps) => {
    appStore.showDialog(<ReservationDialog
        title={'Rezervacija termina bo potekla čez eno minuto'}
        body={props.canExtend
            ? 'S klikom na spodnji gumb lahko rezervacijo podaljšate.'
            : 'Pohitite s prijavo, saj bo rezervacija v kratkem potekla. '}
        action={props.canExtend ? 'PODALJŠAJ' : 'NADALJUJ'}
        secondary={props.canExtend ? 'NADALJUJ' : undefined}
        onSecondary={props.canExtend ? () => undefined : undefined}
        onAction={props.canExtend ? props.onExtend : () => undefined}
    />);
};

export const ShowReservationExpiredDialog = () => {
    appStore.showDialog(<ReservationDialog
        title={'Rezervacija termina je potekla'}
        body={'Rezervacija termina je potekla. Ponovno izberite termin.'}
        action={'IZBERI TERMIN'}
        onAction={() => undefined}
    />);
};

const ReservationWarningToast = (props: WarningToastProps) => {
    const theme = useTheme() as Theme;
    return <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
        <theme.textTheme.body.span>
            Rezervacija termina bo potekla čez {props.minutes} minut.
        </theme.textTheme.body.span>
        {props.canExtend && <CvvButton
            onClick={props.onExtend}
            height={'34px'}
            style={{padding: 0, borderRadius: '4px', justifyContent: 'center'}}>
            PODALJŠAJ
        </CvvButton>}
    </div>;
};

export const showReservationWarningToast = (props: WarningToastProps) => {
    toast.warning(<ReservationWarningToast {...props}/>, {
        toastId: WARNING_TOAST_ID,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
    });
};

export const dismissReservationWarningToast = () => toast.dismiss(WARNING_TOAST_ID);